import {
    DXP_BANNER_GET,
    DXP_BANNER_GET_ERROR,
    DXP_BANNER_SELECT,
    DXP_BANNER_ADD,
    DXP_BANNER_ADD_ERROR,
    DXP_BANNER_UPDATE,
    DXP_BANNER_UPDATE_ERROR,
    DXP_BANNER_DELETE,
    DXP_BANNER_DELETE_ERROR,
} from "../actions/types";

const initialState = {
    count: null,
    featuredBanner: [],
    selectedBanner: null,
    isLoading: true,
    success: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case DXP_BANNER_GET:
            return {
                ...state,
                featuredBanner: payload,
                isLoading: false,
                success: true,
            };
        case DXP_BANNER_SELECT:
            return {
                ...state,
                selectedBanner: payload,
                isLoading: false,
                success: true,
            };
        case DXP_BANNER_ADD:
        case DXP_BANNER_UPDATE:
        case DXP_BANNER_DELETE:
            return {
                ...state,
                isLoading: false,
                success: true,
            };
        case DXP_BANNER_GET_ERROR:
            return {
                ...state,
                featuredBanner: payload,
                isLoading: false,
                success: true
            }
        case DXP_BANNER_ADD_ERROR:
        case DXP_BANNER_UPDATE_ERROR:
        case DXP_BANNER_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                success: true
            }
        default:
            return state;
    }
}
